module.exports = "cat-menu-left .main-content {\n  margin-top: 80px; }\n\n.hidden {\n  visibility: hidden; }\n\n.dropdown:hover .dropdown-menu {\n  display: block;\n  margin-top: 0; }\n\n.logout {\n  font-size: 17px;\n  color: whitesmoke;\n  margin-top: 1em;\n  border-radius: 0px;\n  height: 28px;\n  background-color: #546a7d; }\n\n.te a:hover {\n  background-color: white;\n  color: #546a7d; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home-page/menu-left/menu-left.component.scss
// module id = ./src/app/home-page/menu-left/menu-left.component.scss
// module chunks = main